<template>
    <div>
        <b-card no-body v-show="mostrarFornecedores">
            <b-card-header>
                <h5>FORNECEDORES</h5>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    idTabela="tblFornecedores"
                    :itens="fornecedores"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >
                    <template slot="cpfCnpj" slot-scope="data">
                        <span>{{ data.cpfCnpj | toCpfCnpj }}</span>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <span
                            class="text-primary"
                            v-if="$temAcessoView('GEST-FORNECEDORES-01')"
                        >
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="
                                    detalharFornecedor(data.fornecedorId)
                                "
                            ></i>
                        </span>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view
            :fornecedor="fornecedor"
            v-if="fornecedor.fornecedorId"
        ></router-view>
    </div>
</template>

<script>
import FornecedoresServicos from './FornecedoresServicos'
// import BtnImportarDirf from './BtnImportarDirf'

export default {
    //   props: {
    //     expressoPlanilhas: {
    //       type: Array,
    //       default: () => ([])
    //     }
    //   },
    components: {
        // BtnImportarDirf
    },

    data() {
        return {
            fornecedores: [],
            fornecedor: {},
            campos: [
                {
                    key: 'cpfCnpj',
                    label: 'CNPJ',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'razaoSocial',
                    label: 'Fornecedor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {
        obterFornecedores() {
            this.$store.dispatch('addRequest')
            FornecedoresServicos.obterTodos().then((response) => {
                if (response) {
                    if (response.success) {
                        this.fornecedores = response.data
                        if (this.$route.name != 'Fornecedores') {
                            this.fornecedor = this.fornecedores.filter((p) => {
                                return (
                                    p.fornecedorId ==
                                    this.$route.params.fornecedorId
                                )
                            })[0]
                        }
                    } else {
                        this.$toast.error(
                            'Erro ao obter os Fornecedores',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        detalharFornecedor(fornecedorId) {
            this.fornecedor = this.fornecedores.filter((p) => {
                return p.fornecedorId == fornecedorId
            })[0]
            this.$router.push({
                name: 'Fornecedores_Detalhar',
                params: {
                    fornecedorId
                }
            })
        }
    },

    created() {
        this.obterFornecedores()
    },

    computed: {
        mostrarFornecedores() {
            return this.$route.name == 'Fornecedores'
        }
    },

    watch: {}
}
</script>
